import { colors } from "@minuthq/meatball-ui-react"

import { ReportCard } from "src/components/Reports/ReportCard"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import HomeGroupsIcon from "src/ui/icons/home-groups.svg"
import { MBadge } from "src/ui/MBadge/MBadge"

export function PortfolioAnalyticsReportCard() {
  const { t, langKeys, tPlaceholder } = useTranslate()

  const titleComponents = [
    <div key={t(langKeys.new_badge_title)}>
      <MBadge color="promotional">{t(langKeys.new_badge_title)}</MBadge>
    </div>,
  ]

  return (
    <ReportCard
      icon={
        <HomeGroupsIcon width={24} height={24} color={colors.textPrimary} />
      }
      titleComponents={titleComponents}
      title={tPlaceholder("Portfolio analytics")}
      description={tPlaceholder(
        "See unit uptime and Wi-Fi quality across your entire portfolio. You can also find out how many of your PMS-listed units are linked and actively monitored by Minut."
      )}
      linkTo={Routes.PortfolioAnalytics.location().pathname}
    />
  )
}
